var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5",
    x1: 129.45,
    y1: 214.63,
    x2: 158.85,
    y2: 251.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff575d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff363d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-2",
    x1: 130.51,
    y1: 139.45,
    x2: 157.47,
    y2: 176.21,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-3",
    x1: 197.66,
    y1: 158.26,
    x2: 317.57,
    y2: 158.26,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-4",
    x1: 197.66,
    y1: 233.19,
    x2: 317.57,
    y2: 233.19,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-5",
    x1: 197.66,
    y1: 308.13,
    x2: 317.57,
    y2: 308.13,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-6",
    x1: 129.08,
    y1: 290.38,
    x2: 158.49,
    y2: 324.68,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_4",
    x1: 311.6,
    y1: 323.76,
    x2: 379.4,
    y2: 424.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61ccfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38b9f2"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "order_list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "order_list"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.44,136.5V392.9a20.52,20.52,0,0,1-20.52,20.51H111.73A20.51,20.51,0,0,1,91.22,392.9v-309a20.51,20.51,0,0,1,20.51-20.51H307.42Z",
    style: {
      fill: "#f5efea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.42,63.38h-7.56l41.81,49.3v256.4a20.51,20.51,0,0,1-20.51,20.51H91.22v3.31a20.51,20.51,0,0,0,20.51,20.51H348.92a20.52,20.52,0,0,0,20.52-20.51V136.5Z",
    style: {
      fill: "#ede4dd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.66,
    y: 208.55,
    width: 49.29,
    height: 49.29,
    rx: 14.11,
    style: {
      fill: "url(#New_Gradient_Swatch_copy_5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,248.22V227.15A14.11,14.11,0,0,1,138.67,213h21.07a14,14,0,0,1,6.81,1.76,14.08,14.08,0,0,0-11.72-6.25H133.77a14.11,14.11,0,0,0-14.11,14.11v21.07A14.11,14.11,0,0,0,127,256.08,14,14,0,0,1,124.56,248.22Z",
    style: {
      fill: "#ff8089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,209.66a14,14,0,0,1,1.56,6.43v21.06a14.11,14.11,0,0,1-14.11,14.11H126.72a14.08,14.08,0,0,1-5.51-1.11,14.11,14.11,0,0,0,12.56,7.69h21.06a14.11,14.11,0,0,0,14.11-14.11V222.66A14.12,14.12,0,0,0,160.34,209.66Z",
    style: {
      fill: "#ef2938"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.66,
    y: 133.61,
    width: 49.29,
    height: 49.29,
    rx: 14.11,
    style: {
      fill: "url(#New_Gradient_Swatch_copy_5-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,173.28V152.22a14.11,14.11,0,0,1,14.11-14.11h21.07a14,14,0,0,1,6.81,1.76,14.09,14.09,0,0,0-11.72-6.26H133.77a14.11,14.11,0,0,0-14.11,14.11v21.07A14.09,14.09,0,0,0,127,181.14,14,14,0,0,1,124.56,173.28Z",
    style: {
      fill: "#ff8089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,134.73a14,14,0,0,1,1.56,6.42v21.07a14.11,14.11,0,0,1-14.11,14.11H126.72a14.09,14.09,0,0,1-5.51-1.12,14.11,14.11,0,0,0,12.56,7.69h21.06a14.11,14.11,0,0,0,14.11-14.11V147.72A14.09,14.09,0,0,0,160.34,134.73Z",
    style: {
      fill: "#ef2938"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.46,173.74a8,8,0,0,1-1.87-.22,8.19,8.19,0,0,1-5.29-4l-7.58-13.82a8.17,8.17,0,0,1,14.33-7.86l3.22,5.87,34.92-24.22a8.17,8.17,0,1,1,9.31,13.42l-42.38,29.39A8.16,8.16,0,0,1,146.46,173.74Z",
    style: {
      fill: "#ffc845"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,167.07H206.48a8.82,8.82,0,1,1,0-17.63H308.75a8.82,8.82,0,1,1,0,17.63Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_5-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,242H206.48a8.82,8.82,0,1,1,0-17.63H308.75a8.82,8.82,0,1,1,0,17.63Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_5-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,317H206.48a8.82,8.82,0,1,1,0-17.64H308.75a8.82,8.82,0,0,1,0,17.64Z",
    style: {
      fill: "url(#New_Gradient_Swatch_copy_5-5)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.66,
    y: 283.49,
    width: 49.29,
    height: 49.29,
    rx: 14.11,
    style: {
      fill: "url(#New_Gradient_Swatch_copy_5-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.56,323.16V302.09A14.11,14.11,0,0,1,138.67,288h21.07a14,14,0,0,1,6.81,1.76,14.08,14.08,0,0,0-11.72-6.25H133.77a14.11,14.11,0,0,0-14.11,14.11v21.06A14.09,14.09,0,0,0,127,331,14,14,0,0,1,124.56,323.16Z",
    style: {
      fill: "#ff8089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34,284.6A14,14,0,0,1,161.9,291v21.07a14.11,14.11,0,0,1-14.11,14.11H126.72a14.26,14.26,0,0,1-5.51-1.11,14.1,14.1,0,0,0,12.56,7.68h21.06a14.1,14.1,0,0,0,14.11-14.11V297.6A14.12,14.12,0,0,0,160.34,284.6Z",
    style: {
      fill: "#ef2938"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.51,63.83l62.41,73.62c2.6,3.07.56,8-3.31,8H326.72c-14.91,0-27-12.89-27-28.8V67C299.73,62.66,304.77,60.59,307.51,63.83Z",
    style: {
      fill: "#e2d6cc"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346.46,
    cy: 375.43,
    r: 74.32,
    style: {
      fill: "url(#New_Gradient_Swatch_copy_4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.42,388.5A74.31,74.31,0,0,1,419.91,364a74.32,74.32,0,1,0-143.62,35.85A73.86,73.86,0,0,1,275.42,388.5Z",
    style: {
      fill: "#99e5ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,327.24A74.31,74.31,0,0,1,278.68,405.9,74.31,74.31,0,1,0,403,327.24Z",
    style: {
      fill: "#2db1e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.6,406.45a8.3,8.3,0,0,1-1.72-.18,8.19,8.19,0,0,1-5.29-3.79l-13.7-22.82a8.17,8.17,0,0,1,14-8.41l9.21,15.34,54-37.45a8.17,8.17,0,0,1,9.31,13.42L326.25,405A8.13,8.13,0,0,1,321.6,406.45Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.b4e67697a574b4cdd27a2ba0eb8399d6.svg";
export { ForwardRef as ReactComponent };